import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { VideoComponent } from '../video/video.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { VideostreamingComponent } from '../videostreaming/videostreaming.component';

@Component({
  selector: 'app-dvr-connected',
  templateUrl: './dvr-connected.component.html',
  styleUrls: ['./dvr-connected.component.scss']
})
export class DvrConnectedComponent implements OnInit {
  dvrconnected: any;
  searchkey: string = '';
  public searchTerm: string = '';
  constructor(private dailog: MatDialog, public campuscctvserviceservice: CampuscctvserviceService,private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.spinner.show()
    this.campuscctvserviceservice.getdvrconnected().subscribe((res) => {
      this.dvrconnected = res
      this.spinner.hide()
    });
    this.searchTerm = '';
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    });
    this.search({ event: { target: { value: '' } } });
  }


  // (click)="openvideo(frame)"
  // openvideo(frame: any) {
  //   this.dailog.open(VideoComponent, {
  //     data: frame,
  //     width: '650px', height: '490px',
  //   })
  // }

  openvideostreaming(frame: any) {
    this.dailog.open(VideostreamingComponent, {
      data: frame,
      width: '90%', height: '80%',
    })
  }

  search(event: any) {
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
}

}
